import { render, staticRenderFns } from "./showPillModule.vue?vue&type=template&id=ae8ea19e&scoped=true"
import script from "./showPillModule.vue?vue&type=script&lang=js"
export * from "./showPillModule.vue?vue&type=script&lang=js"
import style0 from "./showPillModule.vue?vue&type=style&index=0&id=ae8ea19e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8ea19e",
  null
  
)

export default component.exports